import { Link } from 'react-router-dom';
import { DashboardSidebar } from '@/layouts/dashboard';
import { FiChevronLeft } from 'react-icons/fi';
export default function BannerSidebar() {
  return (
    <DashboardSidebar
      hasBrand={false}
      viewMode="create"
    >
      <nav className="notebook-sidebar__nav">
        <Link
          to="/banners"
          className="filter-bar__back"
        >
          <div className="card__icon-wrapper">
            <FiChevronLeft />
          </div>
          <span className="filter-bar__back-container">
            <span className="filter-bar__title">Banner informativo</span>
          </span>
        </Link>
      </nav>
    </DashboardSidebar>
  );
}
